export default __webpack_public_path__ + "static/media/customer.a192176e.svg";